export type FooterSocial = {
    id: 'github' | 'linkedin' | 'twitter' | 'email';
    label: string;
    href: string;
};

export type FooterMock = {
    logoSrc: string;
    logoText: string;
    logoAlt: string;
    tagline: string;
    socials: FooterSocial[];
    copyright: string;
    heartLabel: string;
};

export const footerMock: FooterMock = {
    logoSrc: '/assets/logo/wihe_logo.png',
    logoText: 'Mykola',
    logoAlt: 'MT',
    tagline: 'Building the future, one line of code at a time',
    socials: [
        { id: 'github', label: 'GitHub', href: 'https://github.com/Mikirurk1' },
        { id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/in/mykola-teriv/' },
        { id: 'email', label: 'Email', href: 'mailto:teriv168@gmail.com' },
    ],
    copyright: '© 2026 Mykola · Crafted with',
    heartLabel: 'love',
};
